import React, {createContext, useState} from 'react';
import PropTypes from 'prop-types';
import noop from '../utils/noop';

const Context = createContext({
  hasVisitedManage: 0,
  setHasVisitedManage: noop,
  hasVisitedOverview: 0,
  setHasVisitedOverview: noop,
});

export default Context;

export const AppContextProvider = ({children}) => {
  const [hasVisitedManage, setHasVisitedManage] = useState(0);
  const [hasVisitedOverview, setHasVisitedOverview] = useState(0);

  return (
    <Context.Provider
      value={{
        hasVisitedManage,
        setHasVisitedManage,
        hasVisitedOverview,
        setHasVisitedOverview,
      }}>
      {children}
    </Context.Provider>
  );
};

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
